import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";
import {useEffect, useState} from "react";
import DiscountCard, {ActiveDiscountCard} from "./DiscountCard";
import Api from "../../tools/service";
import RequestUrl from "../../tools/defaults/requestUrl";
import LoadingScreen from "../LoadingScreen";

const Discount = ({processInfo, getProcess, token, onClick}) => {
    const [discountPercent, setDiscountPercent] = useState(0);
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const [discountLoading, setDiscountLoading] = useState(false);
    const [discountError, setDiscountError] = useState('');
    const [deleteDiscountLoading, setDeleteDiscountLoading] = useState(false)
    const [deleteDiscountError, setDeleteDiscountError] = useState('')
    const [price, setPrice] = useState(null);
    const [discountPreLoading, setDiscountPreLoading] = useState(true);
    useEffect(() => {
        if(processInfo){
            setPrice(processInfo.payment.info.init_amount);
        }
        if (processInfo?.discount) {
            setDiscountPercent(processInfo.discount.props['Estate'].post_add_on);
            setPrice(processInfo.payment.info.init_amount);
            setDiscountPreLoading(false)
        } else {
            if (localStorage.getItem('discount_code')) {
                setDiscountPreLoading(true)
                const params = {
                    pid: processInfo.pid,
                    code: localStorage.getItem('discount_code')
                }
                Api.post(RequestUrl.ESTATE.DISCOUNT, params, {

                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }).then(response => {
                    localStorage.removeItem('discount_code');
                    setDiscountPreLoading(false)
                    if (response.hasError) {

                    } else {
                        getProcess(processInfo.pid)
                    }
                }).finally(() => {

                })
            } else {
                setDiscountPercent(0)
                setDiscountPreLoading(false)
            }

        }

    }, [processInfo]);
    const handleDiscount = (discount_code) => {
        setDiscountLoading(true);
        const data = {
            pid: processInfo.pid,
            code: discount_code,
        }
        Api.post(RequestUrl.ESTATE.DISCOUNT, data, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.hasError) {
                setDiscountError(response.message);
            } else {
                getProcess(processInfo.pid)
            }
        }).finally(() => {
            setDiscountLoading(false);
        })

    }
    const handleDeleteDiscount = () => {
        setDeleteDiscountLoading(true);
        const params = {
            pid: processInfo.pid,
        }
        Api.delete(RequestUrl.ESTATE.DISCOUNT, {
            params,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.hasError) {
                setDeleteDiscountError(response.message);
            } else {
                getProcess(processInfo.pid)
            }
        }).finally(() => {
            setDeleteDiscountLoading(false);
        })
    }
    const DiscountBadge = () => {
        if (discountPercent === 0) {
            return null
        }
        if (discountPercent === 100) {
            return <div
                className="text-sm rounded-full bg-green-500 text-white px-3 py-1 absolute -top-3 right-2">{`رایگان`}</div>
        }
        return <div
            className="text-sm rounded-full bg-green-500 text-white px-3 py-1 absolute -top-3 right-2">{`${discountPercent}% تخفیف`}</div>
    }
    const Price = () => {
        if(processInfo?.payment?.payment_required===false) {
            return <div className="flex justify-end items-center">
                     <span className="font-semibold text-green-500">
                        رایگان
                     </span>
                    </div>
        } else if (discountPercent === 100) {
            return <div className="flex justify-between items-center">
                <span className="line-through text-red-500">{formattedPrice.format(price / 10)}
                    <span className="mr-1">تومان</span></span>
                <span className="font-semibold text-green-500">رایگان</span>
            </div>
        } else if (discountPercent === 0) {
            return <div className="flex justify-end items-center">
                <span className="font-semibold text-green-500">{formattedPrice.format(price / 10)}
                    <span className="mr-1">تومان</span></span>

            </div>
        } else return <div className="flex justify-between items-center">
            <span className="line-through text-sm text-red-500">{formattedPrice.format(price / 10)}
                <span className="mr-1">تومان</span></span>
            <span
                className=" font-semibold text-green-500">{formattedPrice.format((price - (price * discountPercent / 100)) / 10)}
                <span className="mr-1">تومان</span></span>
        </div>
    }
    if(discountPreLoading){
       return  <LoadingScreen/>
    }
    return <div className="h-full w-11/12 mx-auto md:w-10/12 lg:w-6/12 xl:w-4/12 ">
        <h1 className="font-bold text-xl  mt-3 text-center mb-3 ">ونیفای</h1>
        <div className="bg-white p-5 relative mb-1 rounded-lg shadow-sm  ">
            <DiscountBadge/>
            <h1 className="font-semibold">تایید اصالت سند ملکی</h1>
            <p className="text-sm">این تاییدیه باعث افزایش بازدید آگهی شما شده و فروش ملک را برایتان آسان‌تر
                می‌سازد.</p>
            {price !== null && <Price/>}
        </div>
        {processInfo?.payment?.payment_required===true  && <>
            {!processInfo?.discount &&
                <DiscountCard errorMessage={discountError} loading={discountLoading} onConfirm={handleDiscount}/>}
            {processInfo?.discount && <ActiveDiscountCard
                canDelete={true}
                loading={deleteDiscountLoading}
                error={deleteDiscountError}
                code={processInfo?.discount?.code}
                onDelete={handleDeleteDiscount}/>}
        </>}

        <BottomButtonWrapper><Button onClick={onClick} rounded="rounded-lg" className="text-sm" theme="green">مرحله
            بعد</Button></BottomButtonWrapper>
    </div>
}
export default Discount;